import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../../redux/root';
import { setPermittingPristine, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import SubmissionChip from './SubmissionChip';

const PackageEachSubmission = () => {
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const dispatch = useDispatch();
  const isYes = selectedJurisdiction?.permitting?.isPackageSub === 'yes';

  const onToggle = () => {
    dispatch(setPermittingPristine(false));
    dispatch(
      setSelectedJurisdiction({
        ...selectedJurisdiction,
        permitting: {
          ...selectedJurisdiction.permitting,
          isPackageSub: isYes ? 'no' : 'yes',
        },
      }),
    );
  };

  return (
    <Section>
      <SectionHeader>Package each submission</SectionHeader>
      <ChipRow>
        <SubmissionChip label="Yes" checked={isYes} onToggle={onToggle} />
      </ChipRow>
    </Section>
  );
};

export default PackageEachSubmission;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--neutral-0);
`;

const SectionHeader = styled.div`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-600);
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;
